// extracted by mini-css-extract-plugin
export const ctaButton = "styles-module--ctaButton--1Zdis";
export const arrow = "styles-module--arrow--1mXHL";